module.exports = function (fox) {
    var FormElementBase = require('./base')(fox);

    /**
     * {
     *     type: 'computed',
     *     combine: ['field-2', 'field-1'],
     *     formatter: function (values) {return {get: function, set: function}}
     * }
     */

    function defaultFormatter (values) {
        return {
            get: function () {return values.join('/');},
            set: function () {return values.split('/');}
        };
    }

    return fox.extend({
        __constructor: function () {
            this.super('__constructor', arguments);

            this.combine = fox.isArray(this.params.combine) && this.params.combine || [];
            this.formatter = fox.isFunction(this.params.formatter) && this.params.formatter || defaultFormatter;

            if (this.combine.length) {
                this.formLayer.wait('@this', 'internal_form_ready', {
                    prefix: [this.key, 'form', 'ready'].join('_'),
                    sync: true
                }).then(this.onFormReady.bind(this));
            }
        },

        onFormReady: function () {
            if (!this.combine.length) {
                this.formLayer.removeOption('elements' + this.key);
                return this.formLayer.removeElement(this.key);
            }

            this.combine.forEach(function (key) {
                if (key in this.formLayer._elements) {
                    this.formLayer._elements[key].skip = true;

                    this.formLayer.handleEvent('@this', 'change_' + key, function (params) {
                        this.dispatchEvent('change', {value: this.getValue()});
                    }.bind(this), {
                        prefix: [key, 'events', 'proxy', 'to', this.key].join('_'),
                        sync: true
                    });
                }
            }, this);
        },

        getValue: function () {
            var _this = this;

            var returnValue = this.combine.reduce(function (prev, next) {
                var value = this.formLayer.getElement(next).getValue();

                if (!('async' in prev) && fox.isPromise(value)) {
                    prev.async = value.then(function (value) {
                        prev.values.push(value);

                        return value;
                    });
                } else if ('async' in prev) {
                    prev.async = prev.async.then(function () {
                        return fox.isPromise(value) ? value : fox.Promise.resolve(value);
                    }).then(function (value) {
                        prev.values.push(value);

                        return value;
                    });
                } else {
                    prev.values.push(value);
                }

                return prev;
            }.bind(this), {values: []});

            if ('async' in returnValue) return returnValue.async.then(function () {
                this.value = this.formatter(returnValue.values).get();

                return this.super('getValue', arguments);
            }.bind(this));

            this.value = this.formatter(returnValue.values).get();

            return this.super('getValue', arguments);
        },

        setValue: function (value) {
            var _this = this;
            var values = this.formatter(value).set();

            if (fox.isArray(values) && values.length === this.combine.length) {
                values.forEach(function (value, idx) {
                    this.formLayer.getElement(this.combine[idx]).setValue(value);
                }, this);

                return this.super('setValue', arguments);
            }

            return this;
        },

        _returnValidateResult: function () {
            return fox.merge(this.super('_returnValidateResult', arguments), {
                combine: this.combine
            });
        },

        disable: function () {
            return this.combine.every(function (field) {
                return this.formLayer.disable(field); 
            }, this) && this.super('disable', arguments);
        },

        enable: function () {
            return this.combine.every(function (field) {
                return this.formLayer.enable(field); 
            }, this) && this.super('enable', arguments);
        }
    }, FormElementBase, null, 'FormElementComputed');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/computed.js
// module id = 97
// module chunks = 0